/* Kidlio theme behaviour. No dependencies; everything degrades to plain HTML. */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Mobile menu ---------------------------------------------------------- */
  const toggle = document.querySelector('[data-kd-menu-toggle]');
  const menu = document.querySelector('[data-kd-mobile-menu]');
  if (toggle && menu) {
    const label = toggle.querySelector('[data-kd-menu-label]');
    const setOpen = (open, { focusToggle = false } = {}) => {
      toggle.setAttribute('aria-expanded', String(open));
      menu.hidden = !open;
      document.documentElement.classList.toggle('kd-menu-open', open);
      if (label) label.textContent = open ? label.dataset.close : label.dataset.open;
      if (open) {
        const first = menu.querySelector('a, button');
        if (first) first.focus();
      } else if (focusToggle) {
        toggle.focus();
      }
    };
    toggle.addEventListener('click', () => setOpen(toggle.getAttribute('aria-expanded') !== 'true'));
    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) setOpen(false);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !menu.hidden) setOpen(false, { focusToggle: true });
    });
    window.matchMedia('(min-width: 990px)').addEventListener('change', (event) => {
      if (event.matches) setOpen(false);
    });
  }

  /* Header elevation on scroll ------------------------------------------ */
  const header = document.querySelector('[data-kd-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Launch-list form validation ----------------------------------------- */
  // The form still posts natively to Shopify; this only adds friendly,
  // screen-reader-announced validation before the request is sent.
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  document.querySelectorAll('form.kd-signup').forEach((form) => {
    const email = form.querySelector('input[type="email"]');
    const consent = form.querySelector('.kd-consent__box');
    if (!email) return;
    form.setAttribute('novalidate', '');

    const showError = (input, key, invalid) => {
      const msg = form.querySelector(`[data-kd-error-for="${key}"]`);
      input.setAttribute('aria-invalid', String(invalid));
      if (!msg) return;
      msg.hidden = !invalid;
      msg.textContent = invalid ? msg.dataset.msg : '';
    };

    email.addEventListener('input', () => {
      if (email.getAttribute('aria-invalid') === 'true' && EMAIL.test(email.value.trim())) showError(email, 'email', false);
    });
    if (consent) consent.addEventListener('change', () => consent.checked && showError(consent, 'consent', false));

    form.addEventListener('submit', (event) => {
      const emailOk = EMAIL.test(email.value.trim());
      const consentOk = !consent || consent.checked;
      showError(email, 'email', !emailOk);
      if (consent) showError(consent, 'consent', !consentOk);
      if (!emailOk || !consentOk) {
        event.preventDefault();
        (!emailOk ? email : consent).focus();
        return;
      }
      // Shopify's spam check (hCaptcha) may hold the submission or show a
      // challenge the visitor can close, so never leave the button stuck.
      const button = form.querySelector('button[type="submit"]');
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.classList.add('is-loading');
        window.setTimeout(() => {
          button.removeAttribute('aria-busy');
          button.classList.remove('is-loading');
        }, 6000);
      }
    });
  });

  /* Bring server-side form results into view and focus ------------------- */
  const status = document.querySelector('[data-kd-focus-on-load]');
  if (status) {
    status.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
    status.focus({ preventScroll: true });
  }

  /* Dialogs (store-owner password) -------------------------------------- */
  document.querySelectorAll('[data-kd-dialog-open]').forEach((button) => {
    const dialog = document.getElementById(button.dataset.kdDialogOpen);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    button.addEventListener('click', () => dialog.showModal());
  });
  document.querySelectorAll('[data-kd-dialog-close]').forEach((button) => {
    button.addEventListener('click', () => button.closest('dialog').close());
  });
  document.querySelectorAll('[data-kd-open-dialog]').forEach((el) => {
    const dialog = document.getElementById(el.dataset.kdOpenDialog);
    if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
  });

  /* Gentle reveal on scroll --------------------------------------------- */
  const reveals = document.querySelectorAll('.kd-reveal');
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach((el) => el.classList.add('is-visible'));
  } else {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );
    reveals.forEach((el) => io.observe(el));
  }
})();
